const testIds = {
  hotel_postal_address: 'hotel_postal_address',
  hotel_map: 'hotel_map',
  hotel_access: 'hotel_access',
  hotel_tel: 'hotel_tel',
  hotel_sightseeing: 'hotel_sightseeing',
};

export default testIds;
